import React from 'react';

export default function TabularDataCell(props) {
	if (props.cellData.value !== null || props.cellData.value !== undefined) {
		if (props.cellData.value === 'CHECK') {
			return (
				<div className="comparison-table__content-item">
					<div className="checkfeature"></div>
				</div>
			);
		} else if (props.cellData.value === 'UNCHECK') {
			return <div className="comparison-table__content-item"></div>;
		} else {
			return (
				<div className="comparison-table__content-item">
					<p className="textfeature">{props.cellData.value}</p>
				</div>
			);
		}
	} else {
		console.error('%c There is a problem with the cell data, please check source! ', 'background: orange; color: black');
		return null;
	}
}
